import { CommonModule, NgClass, NgStyle } from '@angular/common';
import { Component, input } from '@angular/core';
import { ThousandsDelimiterPipe } from '@shared/core';
import { UICard } from '@shared/ui';
import { DashboardGroupedStatisticInfoModel } from '../../models';

@Component({
  selector: 'aggregator-dashboard-type-info',
  templateUrl: './type-info.component.html',
  styleUrl: './type-info.component.scss',
  standalone: true,
  imports: [NgStyle, NgClass, UICard, CommonModule, ThousandsDelimiterPipe],
})
export class DashboardTypeInfoComponent {
  data = input<DashboardGroupedStatisticInfoModel>();
}
